An individual component of a physical address.
